/**
 * TODO: Move all Guest functionality (Guest and guestData) here from legacy code
 * (move var Guest, guestData_clear, window.guestData.weather, guestData['rcu_data'],
 * guestData.tv_channels_lang_stream, guestData.groups) + check what filter_content_by_group does
 */

import {inject, Injectable} from './di';
import {BehaviorSubject} from 'rxjs';
import {Logger} from './logger';
import type {AppConfig} from './config/app-config';

/**
 * Service for managing guest data
 * Handles guest authentication, groups, and related functionality.
 */
@Injectable()
export class GuestService {
  private readonly logger = inject(Logger);

  public readonly guestGroups$ = new BehaviorSubject<string[]>([]);

  constructor() {
    // TODO: legacy
    window.guestData = {
      _groups: [],
      groups: [],
      hasGroup: () => false,
    };
    // Override the groups setter
    Object.defineProperty(window.guestData, 'groups', {
      get: function () {
        return window.guestData._groups || [];
      },
      set: (value: string[]) => {
        // Update internal value
        window.guestData._groups = value;

        // Update our subject
        this.guestGroups$.next(value);

        // задержка, чтобы отработал filter_content_by_group
        // TODO: переместить filter_content_by_group в событие groupsUpdated
        setTimeout(function () {
          $(window.HotezaTV).trigger('groupsUpdated');
        }, 1000);

        this.logger.debug('[GuestService] Guest groups updated', value);
      },
    });

    // TODO: Legacy
    window.guestData.hasGroup = (groupName: string) => this.hasGroup(groupName);
  }

  /**
   * Check if the current guest has a specific group
   * @param groupName - The group to check
   * @returns true if the guest has the specified group, false otherwise
   */
  public hasGroup(groupName: string): boolean {
    const groups = this.guestGroups$.value;
    return groups.includes(groupName);
  }
}

declare global {
  interface Window {
    guestData: {
      _groups: string[];
      groups: string[];
      hasGroup: (groupName: string) => boolean;
      weather?: Partial<NonNullable<NonNullable<AppConfig['widgets']>['weather']>>;
    };
  }
  const guestData: Window['guestData'];
}
